export const colorScheme = {
  progressBar: "#05f58f",
  progressBarDots: "#01d77b",
};
